<template>
	<div class="row">
        <div class="content-wrap">
            <ul class="pagination" v-bind:class="[isSticky ? stickyClass : '']"  role="tablist" >                           
                <li v-for="(ele,kye) in main_content " :key="kye" v-bind:class="{'active':(element_id === ele['id_element'])}">
                    <router-link role="tab" :to="'/module/'+module_id+'/category/'+category_id+'/element/'+ele['id_element']+'/division/'+division_id" :aria-selected="element_id === ele['id_element'] ? true : false" v-html="ele['heading']" ></router-link>
                    <h1 v-if="element_id === ele['id_element']" v-html="ele['heading']" class="sr-only"></h1>
                </li>
            </ul>

            <div class="col-md-12" v-if="content_flag==false">
                <span  role="alert" aria-live="assertive" class="sr-only" >{{languageData['loading']}}</span>
                <img  :src="LOCAL_HOST+'/ThemeMegazine/images/loader_dot.gif'" height="20" />
            </div>

            <template v-if="content_flag==true">
            <div class="col-md-12 animate-box" v-for="(el,ky) in main_content_all" :key="ky">
                <div class="archives">
                    <h2>
                        <a class="article-title" :href="'/content/'+el['id_cr']+'/?d='+division_id+'&m='+module_id+'&c='+category_id+'&e='+element_id" v-html="el['title']"></a>
                    </h2>
                    <p v-html="el['teaser']"></p>
                    <p>
                        <router-link :to="'/content/'+el['id_cr']+'/?d='+division_id+'&m='+module_id+'&c='+category_id+'&e='+element_id" :aria-label="languageData['more']+' '+el['title']" v-html="languageData['more']"  class="btn btn-primary with-arrow" v-if="el['view'] !=''"><i class="icon-arrow-right22"></i></router-link>
                        
                        <span v-if="el['rating']>0" class="tag" ><span v-html="languageData['rating']"></span>
                            <span tabindex="0" role="img" :aria-label="el['rating']+' stars out of 5'" v-if="el['rating']>0" class="ratings">                            
                                <template v-for="indx in el['rating']">*</template>
                            </span>
                        </span>
                    </p>
                </div>
            </div>
            <div class="row" id='showLoadMore'>
                <div class="col-md-12 animate-box">
                    <p><a href="" class="mouseover " @click.prevent="loadMorePage()">Load More Results</a></p>
                </div>    
            </div>
            <div class="col-md-12" v-if="this.loadImg==true && this.page != '0'">
                <img  :src="LOCAL_HOST+'/ThemeMegazine/images/loader_dot.gif'" height="20" />
            </div>
            </template>
        </div>   
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'mainContent2',
    data(){
        return{
            main_content:[],
            main_content_all:[],
            CONTENT_DOMAIN:this.$store.state.CONTENT_DOMAIN,
            LOCAL_HOST:this.$store.state.LOCAL_HOST,
            element_id: this.$route.params.element_id,
            division_id:this.$route.params.division_id,
            module_id:this.$route.params.module_id,
            languageData:this.$store.state.languageData,
            category_id:this.$route.params.category_id,
            isSticky: false,
            stickyClass: 'is_sticky',
            content_flag:false,
            loadMore: true,
            loadImg : true,
            page:0,
            limit:10,
            api_call:0
        };        
    },
    components:{
        
    },
    /*mounted :function(){
        this.showContent()
    },*/
     created :function(){
        this.showContent(),
       // this.getElements()
       /*this is to make element menu us sticky based on scroll */
        window.addEventListener('scroll', this.handleScroll)
    },
    destroyed () {
        window.removeEventListener('scroll', this.handleScroll);
    },
    watch: {
        // call again the method if the route changes
        '$route': 'showContent'
    },
    mounted :function(){
        this.handleScroll()
	},
    
	methods:{
        showContent(){
            this.content_flag=false;
            this.category_id=this.$route.params.category_id
            if(this.$route.params.element_id){
                this.element_id=this.$route.params.element_id;
                this.page = 0;
                this.loadMore = true;
                this.getElements(this.$route.params.element_id);                
            }
            //console.log('okkkkkkk');
            this.$emit('content_ld_flagp_false')
            var module_id=this.$route.params.module_id
            var api_private_key=this.get_api_key_mix('mols')
            axios.get(this.$store.state.apiUrl+'/module_cat_details',{
                params:{
                    id_module:'m'+module_id,
                    id_language:this.$store.state.companyData['id_language'],
                    id_company:this.$store.state.companyData['id_company'],
                    id_eap:this.$store.state.companyData['id_eap'],
                    id_country:this.$store.state.companyData['id_country'],
                    id_category:this.category_id,
                    privatekey:api_private_key           
                }
            })
            .then(response => {
                response = response.data
                //console.log(response);                
                this.main_content = response;
                this.content_flag=true;
                this.$emit('content_ld_flagp_changed');               
                this.$nextTick(function () {
                })
                
            })
            .catch((error) => {
                this.main_content = [];
                this.customErrorHandler(error.response.status);
            });
            this.web_hits()
        },

        getElements(element_id,scrollFlag=0){
            this.element_id=element_id;
            if(scrollFlag==0){
                this.content_flag=false;        
                //console.log('okkkkkkkssssssssssssssssssssssss');        
                this.$emit('content_ld_flagp_false')
            }
            var module_id=this.$route.params.module_id
            var api_private_key=this.get_api_key_mix('mots')
            axios.get(this.$store.state.apiUrl+'/mod_cat_viewallelements',{
                params:{
                    id_module:'m'+module_id,
                    id_language:this.$store.state.companyData['id_language'],
                    id_company:this.$store.state.companyData['id_company'],
                    id_eap:this.$store.state.companyData['id_eap'],
                    id_country:this.$store.state.companyData['id_country'],
                    id_element:element_id,
                    id_category:this.category_id,
                    privatekey:api_private_key,
                    page:this.page,
                    limit:this.limit           
                }
            })
            .then(response => {
                response = response.data
                //console.log(response);
                if(scrollFlag==0){
                    this.main_content_all = response;
                    this.content_flag=true;
                    document.getElementById('showLoadMore').style.display = 'block';
                    this.$emit('content_ld_flagp_changed');               
                    this.$nextTick(function () {
                    })
                } else {
                    if(response.length > '0'){
                        this.main_content_all = this.main_content_all.concat(response);
                        document.getElementById('showLoadMore').style.display = 'block';
                    } else {
                        this.loadMore = false;
                        document.getElementById('showLoadMore').style.display = 'none';
                    } 
                }
                this.loadImg = false;
                this.api_call=0;
            })
            .catch((error) => {
                this.main_content_all = [];
                this.customErrorHandler(error.response.status);
            });
        },
        handleScroll(event){
            /*this is to make element menu us sticky based on scroll */
            this.scrollPosition = window.scrollY
            if(this.scrollPosition>=350){
                this.isSticky=true
            }else{this.isSticky=false}
            window.onscroll = () => {
                if(screen.width <= '991'){
                    if(this.scrollPosition >= (this.$el.clientHeight - 500)  && this.loadMore && this.api_call==0){
                        this.loadImg = true;
                        ++this.page;
                        this.api_call=1;
                        this.getElements(this.element_id,1);
                    }
                } else {
                    let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight === document.body.offsetHeight;

                    if (bottomOfWindow && this.loadMore && this.api_call==0) {
                        this.loadImg = true;
                        ++this.page;
                        this.api_call=1;
                        this.getElements(this.element_id,1);
                    }
                }
            };
        },
        loadMorePage(){
            document.getElementById('showLoadMore').style.display = 'none';
            this.loadImg = true;
            ++this.page;
            this.getElements(this.element_id,1);
        }

    }
};
</script>
<style scoped>
.content-wrap {
    padding-right: 17px;
}
.pagination{
    padding-left: 16px;
}
.pagination li a {
    border: none;
    padding: 10px 18px !important;
}

.pagination li a:hover, .pagination li a:focus,.pagination li.active a:hover, .pagination li.active a:focus  {
    border: none !important; 
}
.pagination li.active a {
    border: none !important; 
}
.archives{
    padding-bottom: 0px;
}
.archives .tag {
    margin: 10px 0 0 0;
    font-size: 10px;
    font-weight: 300;
    text-transform: uppercase;
    letter-spacing: 3px;
    text-align: right;
    float:right;
}
.article-title{
    
    font-weight: 300;
    text-transform: uppercase;
    font-size: 24px;    
    color: #000;
    line-height: 1.3;
}
.ratings{
    font-size: 23px !important;
    color: #e07c56;
    font-weight: bold !important;
    /* font-family: fantasy !important; */
    vertical-align: top;
    vertical-align: -webkit-baseline-middle;
}
.is_sticky {
    position: fixed;
    background-color: #fffffffc;
    top: 0;
    z-index: 1030;
    /* width: 100%; */
    -webkit-animation: .95s ease-in-out 0s normal none 1 running fadeInDown;
    animation: .95s ease-in-out 0s normal none 1 running fadeInDown;
    -webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    /* -webkit-box-shadow: 0 8px 20px 0 rgba(0, 0, 0, 0.1);
    box-shadow: 0 8px 20px 0 rgba(0, 0, 0, 0.1); */       
    padding: 0;
    margin:0;
}
@media screen and (max-width: 768px){
    .content-wrap{
        padding-left: 0 !important; 
    }
}
#showLoadMore{
    display: none;
}
.mouseover{
    cursor: pointer;
    float:right;
}
</style>
